// Starting up Alpine 
import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

// Stops JS errors to appear on the Console
require("console-polyfill/index");